import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
    createValidator, decimal, required,
} from '../../utils/validation';
import { createProspects } from '../../state-management/actions/prospect'
import './report.scss';
import { useNavigate, useLocation } from "react-router-dom";
import { saveQuestionsProgressSuccess } from '../../state-management/actions/assessmentSectionQuestions';
import { clearProspect } from '../../state-management/actions/prospect';

export const validate = createValidator({
    firstName: [
        required(),
    ],
    lastName: [
        required(),
    ],
    email: [
        required(),
    ],
    company: [
        required(),
    ],
    jobType: [
        required(),
    ],
    phoneNmber: [
        decimal(),
    ],
});


const HeaderFooterContainer = ({ children, className }) => (
    <div className={`header-footer__${className}`} >
        <div
            className={`header-footer `}
        >
            {children}
        </div>
    </div >
);

export const ClientProspect = (props) => {
    const { report: { title: _title, description: _description, score: _score, _interpretation }, clearProspectAction, saveReport } = props;
    const navigate = useNavigate();
    const { state } = useLocation();

    const { title: __title, description: __description, score: __score, interpretation: __interpretation } = state || {};

    const score = _score || __score;
    const description = _description || __description
    const interpretation = _interpretation || __interpretation;
    const title = _title || __title;

    useEffect(() => {
        if (!title) {
            navigate("/");
        }
    }, [title, navigate]);

    useEffect(() => {
        clearProspectAction();
    }, [clearProspectAction]);

    useEffect(() => {
        if (score) {
            saveReport({ score, description, interpretation, title });
        }
    }, [score, description, interpretation, title, saveReport]);

    const scoreTableClassName = 'report__score-table__item report__score-table__item__';

    return (
        <React.Fragment>
            <HeaderFooterContainer className="header-container">
                <h2 className="heading3 header-footer__header">Your Results</h2>
            </HeaderFooterContainer>
            <div className="report">
                <h1 className='heading2 report__title'>{title}</h1>
                <p className='report__description'>{description}</p>
                <div className='report__score-table'>
                    <div className={`${scoreTableClassName}${((score < 1) || (score > 3)) ? 'dark' : 'light'}`} >Not a Natural Strength</div>
                    <div className={`${scoreTableClassName}${score === 1 ? 'dark' : 'light'}`}  >Area For development</div>
                    <div className={`${scoreTableClassName}${score === 2 ? 'dark' : 'light'}`}  >Emerging Strength</div>
                    <div className={`${scoreTableClassName}${score === 3 ? 'dark' : 'light'}`}  >Clear Strength</div>
                </div>
                <h2 className='report__title__interpretation'>Score Interpretation</h2>
                <p className='report__interpretation'>{interpretation}</p>
            </div>
            <HeaderFooterContainer className="footer-container" >
                <h2 className="heading3 header-footer__footer">Ready to see what our talent solutions can do for you? <a href="https://chally.com/request-a-sales-call/" target="_blank" rel="noreferrer" >Request a call</a></h2>
            </HeaderFooterContainer>
        </React.Fragment >

    );
}

ClientProspect.propTypes = {
    onCreateProspects: PropTypes.func,
    report: PropTypes.shape({}),
};

ClientProspect.defaultProps = {
    onCreateProspects: () => { },
    report: {},
    isLoading: true,
};
const mapStateToProps = (state) => ({
    report: state?.assessmentSectionQuestions?.report,
    isLoading: state?.assessmentSectionQuestions?.isLoading
});

const mapDispatchToProps = dispatch => ({
    onCreateProspects: (values, actions) => dispatch(createProspects(values, actions)),
    saveReport: (report) => dispatch(saveQuestionsProgressSuccess(report)),
    clearProspectAction: () => dispatch(clearProspect()),
});


export default connect(mapStateToProps, mapDispatchToProps)(ClientProspect);
